export default {
    title: 'Löschen',
    deleteAction: 'Keine Kostenstelle löschen | {count} Kostenstelle löschen | {count} Kostenstellen löschen',
    reallyDelete: 'Möchten Sie die ausgewählten Kostenstellen wirklich löschen?',
    deletedCostCenters: 'Die Kostenstellen wurden gelöscht.'
}